import React, { useState, useEffect } from "react";
import { useWishlist } from "hooks/useStore";
import ListCard from "./list-card";
import WishlistEmpty from "./empty";
import { navigate } from "gatsby";
import WishlistItem from "./list-item";
import { getUrlParam } from "helpers/url-params";
import { useSettings } from "hooks/useStore";
import { fetchListContents } from "services/api/swym";

const fetchList = async (id) => {
	try {
		const listContents = await fetchListContents(id);
		if (!listContents) return;
		return listContents.list;
	} catch (error) {
		console.log(`Failed to fetch list with ID ${id}: ${error.message}`);
	}
};

const Wishlist = ({ data }) => {
	const { savedLists } = useWishlist(["savedLists"]);
	const [selectedList, setSelectedList] = useState();

	const { isClient } = useSettings(["isClient"]);
	const listId = isClient ? getUrlParam("list") : "";
	const sharedListId = isClient ? getUrlParam("sharedlid") : "";

	useEffect(() => {
		const fetchAndSetList = async () => {
			if (listId) {
				const foundList = savedLists?.[listId];
				if (foundList) {
					setSelectedList(foundList);
				}
			} else if (sharedListId) {
				const listContents = await fetchList(sharedListId);
				setSelectedList(listContents);
			}
			else {
				setSelectedList(null);
			}
		};

		fetchAndSetList();
	}, [savedLists, listId]);

	const navigateBack = () => {
		const url = new URL(window.location.href);
		url.searchParams.delete("list");
		navigate(url.pathname + url.search);
		setSelectedList(null);
	};

	const handleListClick = async (id) => {
		const url = new URL(window.location);
		if (!url.searchParams.get("list")) {
			navigate(url.pathname + `?list=${id}`);
		}

		const foundList = savedLists?.[id];
		if (foundList) {
			setSelectedList(foundList);
		}
	};

	return (
		<>
			{selectedList ? <ListCard list={selectedList} sharedList={sharedListId} navigateBack={navigateBack} /> :
				<div className="flex flex-col standard-section-width mx-auto">
					{data?.title &&
						<div className="pb-5 border-b mb-6">
							<h3>{data.title}</h3>
							{data?.subtitle && <p className="text-secondary">{data.subtitle}</p>}
						</div>
					}
					<div className="flex gap-3 sm:gap-6 flex-wrap">
						{Object.values(savedLists).length > 0 ? (
							Object.values(savedLists).map((list, index) => (
								<WishlistItem key={index} list={list} handleListClick={(id) => handleListClick(id)} />
							))
						) : <WishlistEmpty />
						}
					</div>
				</div>
			}
		</>
	);
};

export default Wishlist;